import JobQuantity from "./JobQuantity";

export default JobQuantity;
